module.exports = __webpack_public_path__ + "img/layers-3.21860c64.svg";